import { render, staticRenderFns } from "./NewsFilters.vue?vue&type=template&id=76524ee4&scoped=true&"
import script from "./NewsFilters.vue?vue&type=script&lang=js&"
export * from "./NewsFilters.vue?vue&type=script&lang=js&"
import style0 from "./NewsFilters.vue?vue&type=style&index=0&id=76524ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76524ee4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Dropdown: require('/home/bitrix/frontend/components/form/Dropdown.vue').default})
